export class InventoryTransferDetailModel {
  inventoryTransferDetailId: number = 0;
  inventoryTransferId: number = 0;
  articleId: number = 0;
  quantity: number = 0;
  createDate: Date = new Date;
  userNameCreate: string = "";
  updateDate: string | null = null;
  userNameUpdate: string | null = null;

  //variable para controlar si están limpiando el formulario:
  clearForm: boolean = true;
}
